export default __webpack_public_path__ + "static/media/experience.a381f99a.png";